import { render } from "./loading.vue?vue&type=template&id=49ef6051&scoped=true"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=49ef6051&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ef6051"]])

export default __exports__